import { createContext } from 'react';

import { MyPhoneCall } from '../../types';

export interface CallHistoryContextType {
  callHistory: MyPhoneCall[];
  isLoading: boolean;
  hasMore: boolean;
  loadMore: () => Promise<void>;
  refetch: () => Promise<void>;
}

export const CallHistoryContext = createContext<CallHistoryContextType>({
  callHistory: [],
  isLoading: false,
  hasMore: false,
  // eslint-disable-next-line no-empty-function
  loadMore: async() => {},
  // eslint-disable-next-line no-empty-function
  refetch: async() => {},
});
